<template>
  <v-skeleton-loader
    :loading="loading"
    type="image"
    max-height="64"
    :class="{ 'mb-2': loading }"
  >
    <slot />
  </v-skeleton-loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'DashboardTaskSkeleton',

  props: {
    loading: Boolean
  }
});
</script>
